import { gql, useLazyQuery } from '@apollo/client';
import { FC, useEffect, memo } from 'react';
import i18next from '../utils/i18n';
import { currentLanguage } from '../utils/algolia';

const GET_COLLECTIONS_LOCALIZATION = gql`
  query getCollectionsLocalization {
    translations: metaobject(handle: { type: "pimconfig", handle: "translations-categories" }) {
      data: field(key: "data") {
        value
      }
    }
  }
`;

export const useCategoriesLocalization = (loadOnMount = true) => {
  const [getCollectionsLocalization, { data }] = useLazyQuery(GET_COLLECTIONS_LOCALIZATION);

  useEffect(() => {
    if (data?.translations?.data?.value) {
      const categories = JSON.parse(data.translations.data.value);

      i18next.addResourceBundle(currentLanguage, 'collections', categories, true, true);
    } else if (loadOnMount) {
      getCollectionsLocalization();
    }
  }, [loadOnMount, data]);
};

export const CategoriesTranslationsLoader: FC<{ loadOnMount: boolean }> = memo(({ loadOnMount = true }) => {
  useCategoriesLocalization(loadOnMount);

  return null;
});

CategoriesTranslationsLoader.displayName = 'CategoriesTranslationsLoader';
